/**
 * BookingStatusBadge — a colour-coded pill for a canonical lifecycle status.
 * Used in the CRM bookings list, booking detail header/panel, status history
 * and the customer portal. The `note` renders as a native tooltip.
 */
import React from 'react';
import { statusMeta } from '../lib/bookingStatus';

export const BookingStatusBadge = ({ status, note, size = 'sm', testid }) => {
  const m = statusMeta(status);
  const pad = size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-[11px]';
  return (
    <span
      title={note || m.label}
      data-testid={testid || `status-badge-${status || 'unknown'}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${pad} ${m.badge}`}
    >
      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: m.dot }} />
      {m.label}
    </span>
  );
};

export default BookingStatusBadge;
